import { Field } from 'redux-form';
import { getError } from '../../utils';
import { TimeStringPicker } from '../TimeStringPicker';

interface TimeStringPickerRendererProps {
    input?: $TSFixMe; // TODO: pt.shape(fieldInputPropTypes) from redux-form
    meta?: $TSFixMe; // TODO: pt.shape(fieldMetaPropTypes) from redux-form
}

const TimeStringPickerRenderer = ({ input, meta, ...props }: TimeStringPickerRendererProps) => (
    <TimeStringPicker error={getError(meta)} value={input.value} {...props} {...input} />
);

const TimeStringPickerField = (props: $TSFixMe) => <Field {...props} component={TimeStringPickerRenderer} />;

export default TimeStringPickerField;
